const PATTERNS =
  /module factory is not available|ChunkLoadError|Loading chunk .* failed|Loading CSS chunk|Failed to fetch dynamically imported module|error loading dynamically imported module/i;

export const isModuleGraphError = (error: unknown): boolean => {
  if (!error) return false;
  const value = error as { message?: unknown; name?: unknown };
  if (value.name === "ChunkLoadError") return true;
  return typeof value.message === "string" && PATTERNS.test(value.message);
};

export default isModuleGraphError;